import { render, staticRenderFns } from "./TradingType.vue?vue&type=template&id=160488f2&scoped=true&"
import script from "./TradingType.vue?vue&type=script&lang=js&"
export * from "./TradingType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160488f2",
  null
  
)

export default component.exports